/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Form, Input, Row, Col, Select, Upload, Icon, message } from "antd";
import { platformApi } from "../../../../../api";
import { formatValue } from "../../../../../utils";
import { ENDPOINT } from "../../../../../constants";

const { Item } = Form;

const FinancierData = ({
  form,
  validityRef,
  clearRef,
  data,
  setData,
  editable,
  logo,
  setLogo
}) => {
  const { getFieldDecorator } = form;
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [gstType, setGstType] = useState(false);
  const [gstName, setGstName] = useState("");
  const [gstStatus, setGstStatus] = useState("");
  const [gstError, setGstError] = useState(null);

  useEffect(() => {
    // Always load countries first
    platformApi
      .get("/api/csc/country")
      .then((res) => setCountry(res.data.data))
      .catch(() => message.error("Couldn't fetch countries"));

    if (data?.dealerType === "UnregisteredDealer") {
      setGstType(true);
    } else {
      setGstType(false);
    }
    setGstError(null);
    if (!data?.GSTIN) {
      setGstName("");
      setGstStatus("");
    }

    if (data && data.name) {
      // Preload states and cities if address exists
      if (data.address?.country?.id) {
        platformApi
          .post("/api/csc/states", { id: data.address.country.id })
          .then((res) => setState(res.data.data))
          .then(() => {
            if (data.address?.state?.id) {
              platformApi
                .post("/api/csc/cities", { id: data.address.state.id })
                .then((res) => setCity(res.data.data));
            }
          });
      }

      // Set all form values
      form.setFieldsValue({
        name: data.name,
        dealerType: data.dealerType,
        status: data.status,
        GSTIN: data.GSTIN,
        email: data.email,
        "address.line1": data.address?.line1,
        "address.line2": data.address?.line2,
        "address.line3": data.address?.line3,
        "address.locality": data.address?.locality,
        "address.country": data.address?.country?.id,
        "address.state": data.address?.state?.id,
        "address.district": data.address?.district?.id,
        "address.pincode": data.address?.pincode,
      });

      if (data.logo) setLogo(data.logo);
    }

    clearRef.current = () => {
      form.resetFields();
      setLogo(null);
      setFormData(null);
      setGstName("");
      setGstStatus("");
      setGstError(null);
      setGstType(false);
    };

    validityRef.current = () => validatePage();

    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  }, [data]);


  const validatePage = () => {
    let valid;
    form.validateFields((err) => {
      valid = err === null && !gstError;
    });
    if (valid) {
      const values = form.getFieldsValue();
      if (formData) values.logo = logo;
      setData({ ...data, ...values });
    }
    return valid;
  };

  const handleUpload = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
    } else if (info.file.status === "done") {
      const formData = new FormData();
      formData.append("profile", info.file.originFileObj);
      formData.append("master", "Company Master");
      formData.append("module", "Financer");
      formData.append("type", "logo");
      setFormData(formData);
      getBase64(info.file.originFileObj, (url) => setLogo(url));
      setLoading(false);
    }
  };

  const getBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => cb(reader.result));
    reader.readAsDataURL(file);
  };

  const selectParams = (e, type) => {
    if (type === "country") {
      platformApi.post("/api/csc/states", { id: e }).then((res) => {
        setState(res.data.data);
      });
    }
    if (type === "state") {
      platformApi.post("/api/csc/cities", { id: e }).then((res) => {
        setCity(res.data.data);
      });
    }
  };

  const handleDealerTypeChange = (value) => {
    if (value === "UnregisteredDealer") {
      setGstType(true);
      setGstName("");
      setGstStatus("");
      setGstError(null);
    } else {
      setGstType(false);
    }
  };

  const checkGST = async (gst) => {
    try {
      const res = await platformApi.post("/api/gstVerify", { gst });
      const { data } = res;
      if (data?.code === 200) {
        const { response } = data;
        if (response?.code === 200) {
          const payload = response?.data?.data;
          if (payload.taxpayerInfo?.adadr?.[0]?.addr) {
            form.setFieldsValue({
              "address.locality": payload.taxpayerInfo.adadr[0].addr.loc,
              "address.pincode": payload.taxpayerInfo.adadr[0].addr.pncd,
              "address.line1": payload.taxpayerInfo.adadr[0].addr.st,
              "address.line2": payload.taxpayerInfo.adadr[0].addr.bno,
              "address.line3": payload.taxpayerInfo.adadr[0].addr.dst,
            });
          } else if (payload.taxpayerInfo?.pradr?.addr) {
            form.setFieldsValue({
              "address.locality": payload.taxpayerInfo.pradr.addr.loc,
              "address.pincode": payload.taxpayerInfo.pradr.addr.pncd,
              "address.line1": payload.taxpayerInfo.pradr.addr.st,
              "address.line2": payload.taxpayerInfo.pradr.addr.bno,
              "address.line3": payload.taxpayerInfo.pradr.addr.dst,
            });
          }

          if (payload?.error) {
            message.error("GST Invalid");
            setGstName("");
            setGstStatus("");
            return { valid: false, status: "" };
          }
          const taxpayerInfo = payload?.taxpayerInfo || {};
          message.success("GST Verified");
          const status = taxpayerInfo.sts || "";
          setGstName(taxpayerInfo.tradeNam || "");
          setGstStatus(status);
          return { valid: true, status };
        }
      }
      message.error("GST verification failed");
    } catch (err) {
      console.error("GST verification error:", err);
      message.error("GST verification failed");
    }
    setGstName("");
    setGstStatus("");
    return { valid: false, status: "" };
  };

  return (
    <Form layout="vertical" style={{ marginTop: "2vh" }}>
      <Row gutter={16}>
        <Col span={12}>
          <Item label="Financier Name">
            {getFieldDecorator("name", {
              rules: [{ required: true, message: "Enter Financier Name!" }],
            })(
              <Input
                disabled={!editable}
                placeholder="Financier Name"
                pattern="^[a-zA-Z0-9\s]*$"
                onKeyUp={(e) => {
                  const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                  form.setFieldsValue({ name: val });
                }}
              />
            )}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="Dealer Type">
            {getFieldDecorator("dealerType", {
              rules: [{ required: true, message: "Select Dealer Type!" }],
            })(
              <Select
                disabled={!editable}
                placeholder="Select Dealer Type"
                onChange={handleDealerTypeChange}
              >
                <Select.Option value="RegisteredDealer">
                  Registered Dealer
                </Select.Option>
                <Select.Option value="UnregisteredDealer">
                  Unregistered Dealer
                </Select.Option>
                <Select.Option value="UINHolder">UIN Holder</Select.Option>
                <Select.Option value="CompositionDealer">
                  Composition Dealer
                </Select.Option>
              </Select>
            )}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item
            label="GSTIN"
            validateStatus={gstError ? "error" : undefined}
            help={gstError}
            required={true}
          >
            {getFieldDecorator("GSTIN", {
              rules: [
                {
                  required: !gstType,
                  message: "Enter GSTIN!",
                },
              ],
            })(
              <Input
                placeholder="GSTIN"
                maxLength={15}
                disabled={!editable}
                onKeyUp={(event) => {
                  form.setFieldsValue({
                    GSTIN: formatValue(event, "toUpperCase"),
                  });
                }}
                onInput={async (event) => {
                  const value = event.target.value.toUpperCase();
                  form.setFieldsValue({ GSTIN: value });
                  if (!value) {
                    setGstError(null);
                    setGstName("");
                    setGstStatus("");
                    return;
                  }
                  if (value.length === 15) {
                    const { valid, status } = await checkGST(value);
                    if (valid && status === "Active") {
                      setGstError(null);
                    } else if (valid) {
                      setGstError("The GSTIN entered is Inactive");
                    } else {
                      setGstError("Enter Valid GSTIN");
                    }
                  } else {
                    setGstName("");
                    setGstStatus("");
                    setGstError("Enter Valid GSTIN");
                  }
                }}
              />
            )}
          </Item>
          {gstName && (
            <Row type="flex" align="middle">
              <Icon
                style={{ fontSize: 18, marginRight: ".5rem" }}
                type="check-circle"
              />
              <span style={{ color: "green", fontSize: "12px" }}>
                {gstName} ({gstStatus})
              </span>
            </Row>
          )}
        </Col>
        <Col span={12}>
          <Item label="Status">
            {getFieldDecorator("status", {
              rules: [{ required: true, message: "Select Status!" }],
            })(
              <Select placeholder="Status" disabled={!editable}>
                <Select.Option value="ACTIVE">Active</Select.Option>
                <Select.Option value="INACTIVE">Inactive</Select.Option>
              </Select>
            )}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item label="Email">
            {getFieldDecorator("email", {
              rules: [{ type: "email", message: "Enter valid email!" }],
            })(<Input placeholder="Email" disabled={!editable} />)}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="Address Line 1">
            {getFieldDecorator("address.line1", {
              rules: [{ required: true, message: "Enter Address Line 1!" }],
            })(<Input placeholder="Line 1" disabled={!editable} />)}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item label="Address Line 2">
            {getFieldDecorator("address.line2")(
              <Input placeholder="Line 2" disabled={!editable} />
            )}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="Address Line 3">
            {getFieldDecorator("address.line3")(
              <Input placeholder="Line 3" disabled={!editable} />
            )}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item label="Locality">
            {getFieldDecorator("address.locality", {
              rules: [{ required: true, message: "Enter Locality!" }],
            })(
              <Input
                placeholder="Locality"
                disabled={!editable}
                pattern="^[a-zA-Z0-9\s]*$"
                onKeyUp={(e) => {
                  const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                  form.setFieldsValue({ "address.locality": val });
                }}
              />
            )}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="Country">
            {getFieldDecorator("address.country", {
              rules: [{ required: true, message: "Select Country!" }],
            })(
              <Select
                placeholder="Select Country"
                disabled={!editable}
                onSelect={(e) => selectParams(e, "country")}
              >
                {country.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item label="State">
            {getFieldDecorator("address.state", {
              rules: [{ required: true, message: "Select State!" }],
            })(
              <Select
                placeholder="Select State"
                disabled={!editable}
                showSearch
                optionFilterProp="children"
                onSelect={(e) => selectParams(e, "state")}
              >
                {state.map((s) => (
                  <Select.Option key={s.id} value={s.id}>
                    {s.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="City">
            {getFieldDecorator("address.district", {
              rules: [{ required: true, message: "Select City!" }],
            })(
              <Select placeholder="Select City" disabled={!editable} showSearch optionFilterProp="children" >
                {city.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Item label="Pincode">
            {getFieldDecorator("address.pincode", {
              rules: [{ required: true, message: "Enter Pincode!" }],
            })(
              <Input
                placeholder="Pincode"
                maxLength={6}
                disabled={!editable}
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    "address.pincode": formatValue(e, "onlyNo"),
                  })
                }
              />
            )}
          </Item>
        </Col>
        <Col span={12}>
          <Item label="Financier Logo">
            <Upload.Dragger
              disabled={!editable}
              showUploadList={false}
              customRequest={async ({ file, onSuccess, onError }) => {
                try {
                  const formData = new FormData();
                  formData.append("profile", file);
                  formData.append("master", "Company Master");
                  formData.append("module", "Financer");
                  formData.append("type", "logo");

                  const res = await platformApi.post("/api/upload/image", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                  });

                  const uploadedUrl =
                    res.data?.response?.data?.Location || res.data?.response?.data;
                  // setData({...data,logo:res.data?.response?.data?.Location})
                  if (uploadedUrl) {
                    setLogo(uploadedUrl);
                    setFormData(formData);
                    message.success("Logo uploaded successfully!");
                    onSuccess(res.data, file);
                  } else {
                    throw new Error("Invalid upload response");
                  }
                } catch (err) {
                  console.error("Upload failed:", err);
                  message.error("Upload failed!");
                  onError(err);
                }
              }}
              accept=".jpg,.jpeg,.png"
            >
              {logo ? (
                <img src={logo} style={{ width: "100%", maxHeight: 180 }} alt="logo" />
              ) : (
                <div>
                  <p className="ant-upload-drag-icon">
                    <Icon type={loading ? "loading" : "inbox"} />
                  </p>
                  <p className="ant-upload-hint">Click or drag logo to upload</p>
                </div>
              )}
            </Upload.Dragger>
          </Item>
        </Col>
      </Row>
    </Form>
  );
};

const WrappedFinancierDataForm = Form.create({ name: "FinancierDataForm" })(
  FinancierData
);
export default WrappedFinancierDataForm;
